module.exports = __webpack_public_path__ + "img/pulled_pork_marinade.100a3fe0.jpg";